import React, { useContext } from "react";
import { themeContext } from "../../lib";

interface IKeyIconProps {
    sizeX?: number;
    sizeY?: number;
}

export const KeyIcon: React.FC<IKeyIconProps> = ({ sizeX = 17, sizeY = 16 }) => {
    const [theme] = useContext(themeContext);

    return (
        <svg width={sizeX} height={sizeY} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11.5002 5.33336C11.6843 5.33336 11.8335 5.18412 11.8335 5.00003C11.8335 4.81593 11.6843 4.66669 11.5002 4.66669C11.3161 4.66669 11.1668 4.81593 11.1668 5.00003C11.1668 5.18412 11.3161 5.33336 11.5002 5.33336Z"
                fill={theme === "dark" ? "white" : "black"}/>
            <path
                d="M2.22416 11.6094C1.9741 11.8593 1.83357 12.1984 1.8335 12.552V14C1.8335 14.1768 1.90373 14.3464 2.02876 14.4714C2.15378 14.5965 2.32335 14.6667 2.50016 14.6667H4.50016C4.67697 14.6667 4.84654 14.5965 4.97157 14.4714C5.09659 14.3464 5.16683 14.1768 5.16683 14V13.3334C5.16683 13.1565 5.23707 12.987 5.36209 12.862C5.48712 12.7369 5.65668 12.6667 5.8335 12.6667H6.50016C6.67697 12.6667 6.84654 12.5965 6.97157 12.4714C7.09659 12.3464 7.16683 12.1768 7.16683 12V11.3334C7.16683 11.1565 7.23707 10.987 7.36209 10.862C7.48712 10.7369 7.65668 10.6667 7.8335 10.6667H7.94816C8.30176 10.6666 8.64084 10.5261 8.89083 10.276L9.4335 9.73336C10.3601 10.0561 11.3687 10.0549 12.2945 9.72986C13.2202 9.40483 14.0083 8.77525 14.5297 7.94411C15.0512 7.11297 15.2751 6.12947 15.1649 5.15452C15.0547 4.17956 14.6169 3.27086 13.9231 2.57707C13.2293 1.88328 12.3206 1.44548 11.3457 1.33528C10.3707 1.22509 9.38722 1.44902 8.55608 1.97045C7.72494 2.49188 7.09536 3.27994 6.77033 4.20571C6.4453 5.13147 6.44407 6.14014 6.76683 7.06669L2.22416 11.6094Z"
                stroke={theme === "dark" ? "white" : "black"} strokeWidth="1.5" strokeLinecap="round"
                strokeLinejoin="round"/>
            <path
                d="M11.5002 5.33336C11.6843 5.33336 11.8335 5.18412 11.8335 5.00003C11.8335 4.81593 11.6843 4.66669 11.5002 4.66669C11.3161 4.66669 11.1668 4.81593 11.1668 5.00003C11.1668 5.18412 11.3161 5.33336 11.5002 5.33336Z"
                stroke={theme === "dark" ? "white" : "black"} strokeWidth="1.5" strokeLinecap="round"
                strokeLinejoin="round"/>
        </svg>


    );
};
